/* eslint-disable no-unused-vars */
import { ReducedMealBreakFormSchemaWithResponse } from './reducedMealBreakFormSchemaWithResponse'

/**
 * Class representing the shift record form schema.
 */
export class ShiftRecordFormSchema {
  /**
   * @param {Object} params
   * @param {ReducedMealBreakFormSchemaWithResponse} params.reducedMealBreak
   */
  constructor({ reducedMealBreak }) {
    /**
     * Relates to the schema for the reduced meal break dynamic field and
     * data that can be prefilled into it, if set.
     * @type {ReducedMealBreakFormSchemaWithResponse}
     */
    this.reducedMealBreak = reducedMealBreak
  }
}
